import { render } from "./PasswordReset.vue?vue&type=template&id=ce38d50a&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"

import "./PasswordReset.vue?vue&type=style&index=0&id=ce38d50a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce38d50a"]])

export default __exports__